import { type AsyncReturnType } from "type-fest";
import { type AppContext } from "~/lib/context";
import { CacheKeys } from "~/lib/external/redis/cacheKeys";
import { orderTags } from "~/services/companyTags";

export const listCompanyTags = async (ctx: AppContext) => {
  const tags = await ctx.prisma.companyTag.findMany({
    orderBy: {
      name: "asc",
    },
  });

  return ctx.remember(CacheKeys.CompanyTags, async () => {
    return orderTags(tags);
  });
};

export type ListCompanyTagsResult = AsyncReturnType<typeof listCompanyTags>;
